module.exports = __webpack_public_path__ + "static/media/payroll_success.6fe4a82e.png";